import {
  ArrowLeftCircleIcon,
  ArrowRightCircleIcon,
} from "@heroicons/react/24/solid";

export default function SmartPagination({
  currentPage,
  totalPages,
  onPageChange,
}) {
  // Generate smart page structure
  const getPages = () => {
    const pages = [];

    pages.push(1);

    if (currentPage > 4) pages.push("...");

    for (let i = currentPage - 2; i <= currentPage + 2; i++) {
      if (i > 1 && i < totalPages) pages.push(i);
    }

    if (currentPage < totalPages - 3) pages.push("...");

    if (totalPages > 1) pages.push(totalPages);

    return pages;
  };

  const pages = getPages();

  return (
    <div className="w-full flex flex-col sm:flex-row items-center justify-between gap-4 sm:gap-0 py-4 sm:py-6 px-2">
      {/* LEFT — PAGE TEXT */}
      <p className="text-xs sm:text-sm text-gray-600 hidden sm:block">
        Showing page <span className="font-medium">{currentPage}</span> of{" "}
        <span className="font-medium">{totalPages}</span>
      </p>

      {/* RIGHT — SMART PAGINATION */}
      <nav className="flex items-center justify-center gap-2 sm:gap-3">
        {/* PREV */}
        <button
          onClick={() => currentPage > 1 && onPageChange(currentPage - 1)}
          disabled={currentPage === 1}
          className={`
            p-1 transition-all rounded-full
            ${
              currentPage === 1
                ? "opacity-30 cursor-not-allowed"
                : "hover:scale-110"
            }
          `}
        >
          <ArrowLeftCircleIcon className="w-6 h-6 sm:w-8 sm:h-8 text-toucanTeal" />
        </button>

        {/* PAGE NUMBERS */}
        <div className="flex items-center gap-1 sm:gap-2">
          {pages.map((page, index) =>
            page === "..." ? (
              <span
                key={index}
                className="px-2 sm:px-3 py-1.5 sm:py-2 text-gray-400 text-xs sm:text-sm"
              >
                …
              </span>
            ) : (
              <button
                key={index}
                onClick={() => onPageChange(page)}
                className={`
                  px-3 sm:px-4 py-1.5 sm:py-2 rounded-xl text-xs sm:text-sm font-medium border transition-all
                  ${
                    page === currentPage
                      ? "bg-toucanTeal text-white border-[#00C2C7]"
                      : "text-gray-700 border-gray-200 hover:bg-[#E5F9FF] hover:border-[#B8E6F5]"
                  }
                `}
              >
                {page}
              </button>
            )
          )}
        </div>

        {/* NEXT */}
        <button
          onClick={() =>
            currentPage < totalPages && onPageChange(currentPage + 1)
          }
          disabled={currentPage === totalPages}
          className={`
            p-1 transition-all rounded-full
            ${
              currentPage === totalPages
                ? "opacity-30 cursor-not-allowed"
                : "hover:scale-110"
            }
          `}
        >
          <ArrowRightCircleIcon className="w-6 h-6 sm:w-8 sm:h-8 text-toucanTeal" />
        </button>
      </nav>
    </div>
  );
}
